import { Component, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";

import { MainConfig } from "@atenea-cms";
import { LandingService } from "../shared";

@Component({
  selector: "landing-list",
  templateUrl: "./landing-list.component.html",
  styleUrls: ["./landing-list.component.scss"],
  host: { class: "atn-list-crud" },
})
export class LandingListComponent implements OnInit {
  constructor(
    private titleService: Title,
    private mainConfig: MainConfig,
    public dataService: LandingService
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Landings - " + this.mainConfig.cmsName);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/landings/landing-list/landing-list.component.ts